// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ThemeManager } from '@front/controls/misc/ThemeManager';
import { SolidBrush } from '../../Graphics';
import { DataCacheToolType } from '../DataCacheToolEnums';
import { DataCacheTool } from '../DataCacheTool';
import { DynProperty } from '../../DynProperty';
export class InfoLineDataCacheTool extends DataCacheTool {
    /**
     * Constructor for InfoLineDataCacheTool
     */
    constructor() {
        super();
        this.ToolType = DataCacheToolType.InfoLine;
        this.InitPoints(2);
    }
    /**
     * Gets the maximum points count required for the tool
     * @returns {number} - Maximum points count
     */
    MaxPointsCount() {
        return 2;
    }
    /**
     * Gets the minimum points count required for the tool
     * @returns {number} - Minimum points count
     */
    MinPointsCount() {
        return 2;
    }
    /**
     * Handles theme change event
     */
    ThemeChanged() {
        super.ThemeChanged();
        this.BackgroundColor = ThemeManager.colors.infoLineToolBackground;
        this.FontColor = ThemeManager.colors.infoLineToolForeground;
        this.Color = ThemeManager.colors.infoLineToolColor;
        this.font = ThemeManager.Fonts.Font_12F_regular;
    }
    get BackgroundColor() {
        return this.backgroundColor;
    }
    set BackgroundColor(value) {
        if (this.backgroundColor === value)
            return;
        this.backgroundColor = value;
        this.backgroundBrush = new SolidBrush(this.backgroundColor);
    }
    get BackgroundBrush() {
        return this.backgroundBrush;
    }
    /**
     * Gets the properties of the tool
     * @returns {DynProperty[]} - Array of dynamic properties
     */
    Properties() {
        const oldProps = super.Properties();
        const props = [];
        if (this.font != null) {
            props.push(new DynProperty('Font', this.font.copy(), DynProperty.FONT, DynProperty.VISUAL_GROUP));
        }
        const len = oldProps.length;
        for (let i = 0; i < len; i++) {
            const prop = oldProps[i];
            if (prop.group === DynProperty.NUMERICAL_PARAMETRS_GROUP ||
                prop.group === DynProperty.HIDDEN_GROUP ||
                prop.name === 'Stick to period' ||
                prop.name === 'Color') {
                props.push(prop);
            }
        }
        return props;
    }
    /**
     * Callback function for handling property changes
     * @param {DynProperty[]} properties - Array of dynamic properties
     */
    callBack(properties) {
        super.callBack(properties);
        const prop = DynProperty.getPropertyByName(properties, 'Font');
        if (prop != null)
            this.font = prop.value;
    }
}
